import type { SceneFactProposalAction } from "@sitescene/types";

/**
 * API endpoint paths. Kept in one place so route strings are not scattered
 * across hooks and components.
 */
export const ENDPOINTS = {
	shadow: {
		costs: "/shadow/costs",
		events: {
			byMeasurement: (measurementId: string) =>
				`/shadow/events/by-measurement/${measurementId}`,
			event: (eventId: string) => `/shadow/events/${eventId}`,
			reanalysis: (eventId: string) => `/shadow/events/${eventId}/reanalysis`,
			reanalysisAction: (
				eventId: string,
				reanalysisId: string,
				action: "check" | "force" | "revert",
			) => `/shadow/events/${eventId}/reanalysis/${reanalysisId}/${action}`,
			reanalysisSuggest: (eventId: string) =>
				`/shadow/events/${eventId}/reanalysis/suggest`,
			video: (eventId: string) => `/shadow/events/${eventId}/video`,
		},
		installations: "/shadow/installations",
		me: "/shadow/me",
		organizations: "/shadow/organizations",
		plausibility: {
			aliases: "/shadow/plausibility/aliases",
			calibrationProposals: "/shadow/plausibility/calibration/proposals",
			calibrationReview: (proposalId: string, action: "accept" | "reject") =>
				`/shadow/plausibility/calibration/proposals/${proposalId}/${action}`,
			calibrationRun: "/shadow/plausibility/calibration/run",
			globalPrior: (priorId: string) =>
				`/shadow/plausibility/global/priors/${priorId}`,
			globalPriors: "/shadow/plausibility/global/priors",
			prior: (priorId: string) => `/shadow/plausibility/priors/${priorId}`,
			priors: "/shadow/plausibility/priors",
			replay: "/shadow/plausibility/replay",
			seed: "/shadow/plausibility/seed",
			taxonomy: "/shadow/plausibility/taxonomy",
			unknownLabels: "/shadow/plausibility/unknown-labels",
			unknownLabelsIgnore: "/shadow/plausibility/unknown-labels/ignore",
			verdict: (verificationId: string) =>
				`/shadow/plausibility/verifications/${verificationId}/verdict`,
			verdictSuggest: (verificationId: string) =>
				`/shadow/plausibility/verifications/${verificationId}/verdict/suggest`,
			verification: (verificationId: string) =>
				`/shadow/plausibility/verifications/${verificationId}`,
			verifications: "/shadow/plausibility/verifications",
			verificationVideo: (verificationId: string) =>
				`/shadow/plausibility/verifications/${verificationId}/video`,
		},
		reanalyses: "/shadow/reanalysis",
		sceneFacts: {
			proposal: (proposalId: string) =>
				`/shadow/scene-facts/proposals/${proposalId}`,
			proposalAction: (proposalId: string, action: SceneFactProposalAction) =>
				`/shadow/scene-facts/proposals/${proposalId}/${action}`,
			proposalRetest: (proposalId: string) =>
				`/shadow/scene-facts/proposals/${proposalId}/retest`,
			proposals: "/shadow/scene-facts/proposals",
			proposalVideo: (proposalId: string) =>
				`/shadow/scene-facts/proposals/${proposalId}/video`,
		},
		tenantSettings: "/shadow/tenant/settings",
	},
} as const;
